function getSrc(el) {
  var rawSrc = (el.attr('src') ? el.attr('src') : el.attr('data-src'));
  return rawSrc.replace(/(?=[() ])/g, '\\');
}


$(document).ready(function () {

  // Append visit widget to itinerary planner page
  var currentPath = window.location.pathname;
  var vwIframe = '<iframe src="https://palestinetx.visitwidget.com/" width="100%" height="700px" style="margin: 0 auto; display: block; box-sizing: border-box;" name="vwIframe" id="vwIframe"></iframe>';
  if (currentPath === '/p/about/295') {
    $(".content").append(vwIframe);
  }


  // 
  

  // Search Bar Script
  $('.searchBoxInput input').attr('placeholder', 'Search')
  $('.searchBoxInput input').val('')
  $('#mobileSearchInput').attr('placeholder', 'Search Website')
  $('#mobileSearchInput').val('')

  //Get updates text
  $('.top-inner-bar .emailSignup .emailInputSubmit a').text('')

  // Tickets & Deals
  $('.ticket').text("Tickets")
  $('.mobile-menu-ticket-btn').text("Tickets")

  // TOGGLE
  $('.mobile-nav-toggle').append(`
<div></div>
<div></div>
<div></div>
`)

  // Class for nav items (radius)
  $('.groups .group').each(function () {

    $(this).find('.items > .item').each(function () {
      $(this).addClass('radius-class');

      $(this).find(".subitems > .item").each(function () {
        $(this).addClass(`radius-class`);
      });
    });

    $(this).find('.navClonedItem').removeClass('radius-class')
  });

  // General Message
  $('.generalmessage').prependTo('header');

  // Feature LineUp Customized
  let nmbrSlides = 1
  $('.featureLineupModule .featureLineupContainer').each(function () {
    $(this).find(".subContainer .featureLineupImage").prepend('<div class="overlay-lineup"></div>')

  })


  // Cloned Social sidebar
  $('.socialNetworks').clone().appendTo('.cloned-social')

  // IG Url update
  let igURL = $('.socialNetworkIconInstagram').attr('href')
  $('.social-feed .button').attr('href', igURL)

// Events script
  setTimeout(function () {
    $('#multiScheduleFeature').prependTo('.envet-container')
  }, 1000)

});


$(window).load(function () {

  // Weather Script
  setInterval(function () {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (weatherBugSet || str == '') return
    $('#weatherBugWidget').addClass('weatherBugSet');
    var findSpace = str.lastIndexOf(' ');
    var stringLength = str.length;
    var res = str.substring(findSpace, stringLength);
    var start = str.substring(0, findSpace);
    $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
    $('#weatherBugWidget').css('visibility', 'visible');
  }, 12);
});

